import { useEffect, useState } from "react";
import baseURL from "../../config/api";
import { useNavigate } from "react-router-dom";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import Pagination from "../../components/Pagination";
import { formatUSPhone } from "../../utils/phoneFormatter";
import { format } from "date-fns";
import { AiOutlineSearch } from "react-icons/ai";
import { RiArrowDownSFill } from "react-icons/ri";
import { RxCross1 } from "react-icons/rx";
import useGroup from "../../hook/useGroup";
import Cookies from "js-cookie";

const Directory = () => {
    const token = Cookies.get("token-my-cdir");
    const navigate = useNavigate();
    const { selectedGroupId }: any = useGroup();
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>('');
    const [displayFilter, setDisplayFilter] = useState<boolean>(false);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [memberFilterValue, setMemberFilterValue] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState<string>("Member Name");
    const [showEntries, setShowEntries] = useState<number>(10);
    const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
        page: 0,
        size: 10,
    });
    const [totalLength, setTotalLength] = useState<number>(0);

    const seeFamilyMember = (id: string, name: string) => {
        navigate(`/member/family-members/${id}/${name}`)
    }

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                size: paginationModel.size,
            };

            setPaginationModel(newPaginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            apiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, selectedGroupId])

    const apiCall = (newPaginationModel: { page: number, size: number }) => {
        if (selectedGroupId > 0) {
            setIsDataLoaded(true);
            fetch(`${baseURL}member/GetMemberReportByGroupIdPaging/${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.memberReport.map((item: any) => {
                        return {
                            ...item,
                            name: item.firstName + " " + item.lastName,
                            birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                            imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                            address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                        };
                    })

                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setIsDataLoaded(false);

                }).catch((error) => {
                    console.log(error);
                    setIsDataLoaded(false);
                    setSearchTableData([]);
                    setTotalLength(0);
                });
        }
        else {
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
        }

    }

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    size: paginationModel.size,
                };

                setPaginationModel(newPaginationModel);

            }, 1000);
        }

        return () => clearTimeout(timeOutId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            filteApiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const filteApiCall = (newPaginationModel: { page: number, size: number }) => {
        let filterData: any[] = [];
        setIsDataLoaded(true);
        switch (memberFilterValue) {
            case 0:
                fetch(
                    `${baseURL}member/GetMemberReportByGroupIdAndSearchWithMemberName/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
                    headers: {
                        Authorization: `Bearer ${token?.toString()}`
                    }
                }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.memberReport.map((item: any) => {
                            return {
                                ...item,
                                name: item.firstName + " " + item.lastName,
                                birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                                address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            };
                        })
                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;
            case 1:
                fetch(
                    `${baseURL}member/GetMemberReportByGroupIdAndSearchWithFamilyName/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token?.toString()}`
                        }
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.memberReport.map((item: any) => {
                            return {
                                ...item,
                                name: item.firstName + " " + item.lastName,
                                birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                                address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            };
                        })

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;
            case 2:
                fetch(
                    `${baseURL}member/GetMemberReportByGroupIdAndSearchWithEmailAddress/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token?.toString()}`
                        }
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.memberReport.map((item: any) => {
                            return {
                                ...item,
                                name: item.firstName + " " + item.lastName,
                                birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                                address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            };
                        })

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;
        }
    }

    const applyFilter = () => {
        setSelectedFilter(
            memberFilterValue === 0
                ? "Member Name"
                : memberFilterValue === 1
                    ? "Family Name"
                    : "Email"
        );

        setPaginationModel({ page: 0, size: paginationModel.size });
        setDisplayFilter(false);
    };

    const clearFilter = () => {
        setSearchValue("");
        setMemberFilterValue(0);
        setSelectedFilter("Member Name");
        setPaginationModel({ page: 0, size: paginationModel.size });
        setDisplayFilter(false);
    };

    return (
        <div className="p-3 xm:p-4 lg:p-10 min-h-screen w-full overflow-x-hidden">
            <div className="w-full">
                <div className="max-w-7xl w-full mx-auto">

                    {/* HEADER */}
                    <div className="flex flex-col xm:flex-row xm:items-center xm:justify-between mb-6 xm:mb-8 gap-3">
                        <h1 className="text-xl xm:text-2xl lg:text-3xl font-semibold text-gray-800">
                            Directory
                        </h1>
                    </div>

                    {/* FILTER + SEARCH */}
                    <div className="bg-white rounded-xl shadow-sm border p-3 xm:p-4 mb-6 xm:mb-8 flex flex-col xm:flex-row gap-3 xm:gap-4 items-stretch xm:items-center w-full">

                        {/* FILTER */}
                        <div className="relative w-full xm:w-auto">
                            <button
                                className="bg-secondary text-white px-4 py-2 rounded-lg flex items-center justify-between w-full xm:w-auto"
                                onClick={() => setDisplayFilter(!displayFilter)}
                            >
                                {selectedFilter}
                                <RiArrowDownSFill className="ml-1" />
                            </button>

                            {displayFilter && (
                                <div className="absolute z-10 mt-2 w-full xm:w-44 bg-white border rounded-lg shadow-lg p-3">
                                    <div className="flex justify-between items-center mb-2">
                                        <span className="text-xs font-semibold">Fields</span>
                                        <RxCross1
                                            className="cursor-pointer text-sm"
                                            onClick={() => setDisplayFilter(false)}
                                        />
                                    </div>

                                    <select
                                        className="w-full text-sm border p-1 rounded"
                                        value={memberFilterValue}
                                        onChange={(e) =>
                                            setMemberFilterValue(parseInt(e.target.value))
                                        }
                                    >
                                        <option value="0">Member Name</option>
                                        <option value="1">Family Name</option>
                                        <option value="2">Email</option>
                                    </select>

                                    <div className="flex justify-between mt-3">
                                        <button
                                            className="text-xs bg-secondary text-white px-2 py-1 rounded w-full mr-1"
                                            onClick={applyFilter}
                                        >
                                            Apply
                                        </button>

                                        <button
                                            className="text-xs bg-secondary text-white px-2 py-1 rounded w-full ml-1"
                                            onClick={clearFilter}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* SEARCH */}
                        <div className="flex items-center flex-1 w-full px-3 py-2 border rounded-lg bg-white h-[44px]">
                            <AiOutlineSearch className="text-gray-500 mr-2 shrink-0" />
                            <input
                                type="text"
                                placeholder="Search..."
                                className="w-full outline-none bg-transparent text-sm xm:text-base"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* LIST */}
                    <div className="relative min-h-[400px] xm:min-h-[500px]">
                        <div className={`${isDataLoaded ? "invisible" : "visible"}`}>
                            {searchTableData.length > 0 ? (
                                <div className="grid gap-4 xm:gap-6 grid-cols-1 xm:grid-cols-2 2xl:grid-cols-3">

                                    {searchTableData.slice(0, showEntries).map((item, index) => (
                                        <div
                                            key={index}
                                            className="group bg-white border rounded-2xl shadow-sm hover:shadow-xl transition-all p-4 xm:p-5 flex flex-col xm:flex-row gap-4"
                                        >

                                            {/* IMAGE */}
                                            <div className="w-full xm:w-24 h-40 xm:h-24 rounded-xl overflow-hidden shrink-0">
                                                <img
                                                    src={item.imagePath}
                                                    alt="member"
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>

                                            {/* CONTENT */}
                                            <div className="flex flex-col justify-between flex-1">
                                                <div>
                                                    <h2 className="text-base xm:text-lg font-semibold text-gray-800 break-words">
                                                        {item.familyName}
                                                    </h2>

                                                    <p className="text-xs xm:text-sm text-gray-500">
                                                        {item.name}
                                                    </p>

                                                    <p className="text-xs xm:text-sm text-gray-600 mt-2 break-words">
                                                        {item.address}
                                                    </p>
                                                </div>

                                                <div className="mt-3 text-xs xm:text-sm text-gray-700 space-y-1">
                                                    <div className="flex items-center gap-2">
                                                        <BsFillTelephoneFill size={14} />
                                                        <span className="truncate">
                                                            {formatUSPhone(item?.phoneNumber || "")}
                                                        </span>
                                                    </div>

                                                    <div className="flex items-center gap-2">
                                                        <MdEmail size={14} />
                                                        <span className="truncate">
                                                            {item.emailAddress}
                                                        </span>
                                                    </div>
                                                </div>

                                                <button
                                                    onClick={() => seeFamilyMember(item.id, item.name)}
                                                    className="mt-4 w-full xm:w-fit px-4 py-2 rounded-lg bg-secondary text-white hover:bg-secondary transition"
                                                >
                                                    View Family →
                                                </button>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            ) : (
                                !isDataLoaded && (
                                    <div className="h-[200px] flex justify-center items-center text-gray-500 text-sm">
                                        No Data Found
                                    </div>
                                )
                            )}

                            {totalLength > 0 && (
                                <div className="mt-10 xm:mt-14 flex justify-center">
                                    <Pagination
                                        pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                                        totalLength={totalLength}
                                        paginationModel={paginationModel}
                                        setPaginationModel={setPaginationModel}
                                        showEntries={showEntries}
                                        setShowEntries={setShowEntries}
                                    />
                                </div>
                            )}
                        </div>

                        {/* LOADER */}
                        {isDataLoaded && (
                            <div className="absolute inset-0 flex justify-center items-center bg-white/60 rounded-xl">
                                <div className="h-10 w-10 border-4 border-secondary border-t-transparent rounded-full animate-spin"></div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Directory;